import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user'


Vue.use(Vuex);


const userStore = new Vuex.Store({
    modules: {
        user,
    }
});

export default userStore;



// WEBPACK FOOTER //
// ./src/vuex/index.js